import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const CampaignsDashboard = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Erreur</h3>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <p>API connection failed.</p>
      </Col>
    </Row>
  </Container>
);

export default CampaignsDashboard;
